import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { generateUnhandledFault, translateFault } from '../../helpers/faults';
import { getValidCountriesList } from '../../utils/common';
import externalValidationRules from '../../config/password_config.json';

function useMetaDataCodeTables() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestMetaDataCodeTables = ({
    countries,
    titles,
    subscriberRequirements,
    subscriberLeadSourceCode,
    regex,
  }) => {
    const getRequestPayloads = [
      countries,
      titles,
      subscriberRequirements,
      subscriberLeadSourceCode,
      regex,
    ].reduce((all, requestPayloads) => {
      if (requestPayloads) {
        all.push({
          type: 'code',
          forceRefresh: false,
          payload: [requestPayloads],
        });
      }
      return all;
    }, []);

    const getCountriesList = (payload) => {
      if (payload) {
        return getValidCountriesList(
          WebApi.getMetadataItemByKey('code', payload),
        );
      }
      return null;
    };

    const getMetaDataItem = (payload) => {
      if (payload) {
        return WebApi.getMetadataItemByKey('code', payload);
      }
      return null;
    };

    WebApi.requestAll([...getRequestPayloads])
      .then(() => {
        if (isMounted.current) {
          const metadata = {
            countryRules: getCountriesList(countries),
            titleRules: getMetaDataItem(titles),
            genericRules: getMetaDataItem(subscriberRequirements),
            leadSources: getMetaDataItem(subscriberLeadSourceCode),
            externalValidationRules: externalValidationRules,
            regExRules: getMetaDataItem(regex),
          };
          setUiModel({ ...metadata });
        }
      })
      .catch((error) => {
        console.warn({ error });
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };
  return [uiModel, fault, requestMetaDataCodeTables];
}

export { useMetaDataCodeTables };
export default useMetaDataCodeTables;
